import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-categories',
  templateUrl: './pricing-categories.component.html',
  styleUrls: ['./pricing-categories.component.scss']
})
export class PricingCategoriesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
